const helper = {
  /**
   * 
   * @param {number} cx 
   * @param {number} cy 
   * @param {number} ex 
   * @param {number} ey 
   */
  angle(cx, cy, ex, ey) {
    // https://stackoverflow.com/questions/9614109/how-to-calculate-an-angle-from-points
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]

    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    //if (theta < 0) theta = 360 + theta; // range [0, 360)

    return theta;
  },

  /**
   * @param {number} ax 
   * @param {number} ay 
   * @param {number} bx 
   * @param {number} by 
   */
  distance(ax, ay, bx, by) {
    const dx = Math.pow(ax - bx, 2);
    const dy = Math.pow(ay - by, 2);
    return Math.sqrt(dx + dy);
  },

  /**
   * 
   * @param {number} ax 
   * @param {number} ay 
   * @param {number} bx 
   * @param {number} by 
   * @returns {number}
   */
  bezierBlend(value) {
    return value * value * (3 - 2 * value);
  }

};
export default helper;